import Vue from 'vue';
import utilities from '@/mixins/util.mixin';
import labels from '@/mixins/label.mixin';

Vue.mixin(utilities);
Vue.mixin(labels);
